import { useConfigContext } from '#src/contexts/config/index.ts';

export const useEnabledWheelByRarity = () => {
  const { wheel } = useConfigContext();

  return {
    common: wheel.commonWheelConfig !== null,
    limited: wheel.limitedWheelConfig !== null,
    rare: wheel.rareWheelConfig !== null,
    super_rare: wheel.superRareWheelConfig !== null,
    unique: wheel.uniqueWheelConfig !== null,
  };
};
